<p-dialog [modal]="true" [(visible)]="visible" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
    <ng-template pTemplate="headless">
        <div class="flex flex-col bg-[#FFFFFF] rounded-[16px] font-[Gilroy] p-5">
            <div class="flex flex-col gap-2">
                <p class="text-primary text-xl font-semibold mobile:text-sm">{{
                    'dashboard.add_data' | transloco
                    }}
                </p>
            </div>

            <div class="flex flex-col gap-2">
                <div class="flex flex-col gap-2 overflow-auto h-[50vh] py-5">
                    <div class="w-full flex flex-wrap gap-2 px-2">

                        <!-- For Period -->
                        <div class="flex-[1] self-center min-w-[300px] max-w-[600px]">
                            <app-custom-date-input labelText="{{ 'dashboard.labels.forPeriod' | transloco }}"
                                inputId="forPeriod" placeholder="{{ 'dashboard.placeholders.forPeriod' | transloco }}"
                                [(dateValue)]="forPeriodDate" [errorMessage]="forPeriodInputError"
                                [isDisabled]="saveClicked" dateFormat="dd/mm/yy" boxHeight="min-h-[50px] max-h-[70px]">
                            </app-custom-date-input>
                        </div>

                        <!-- Energy Type Dropdown -->
                        <div class="flex-[1] min-w-[300px] max-w-[600px] self-end">
                            <app-custom-dropdown [options]="energyTypeDropdownOptions"
                                label="{{ 'dashboard.labels.select_energy_type' | transloco }}"
                                [(selectedOption)]="selectedEnergyTypeDropdown" [disabled]="saveClicked"
                                boxHeight="min-h-[50px] max-h-[70px]">
                            </app-custom-dropdown>
                        </div>

                    </div>
                    <div class="w-full flex flex-col gap-2 px-2">
                        <!-- Location Dropdown -->
                        <div class="min-w-[300px] max-w-[600px]">
                            <app-custom-dropdown [options]="locationsDropdownOptions"
                                label="{{ 'dashboard.labels.select_location' | transloco }}"
                                [(selectedOption)]="selectedLocationDropdown" [disabled]="saveClicked"
                                boxHeight="min-h-[50px] max-h-[70px]">
                            </app-custom-dropdown>
                        </div>
                        <a routerLink="/locations" class="text-primary hover:underline hover:cursor-pointer">{{
                            'dashboard.new_location' | transloco }}</a>
                    </div>
                    <div class="w-full flex flex-wrap gap-2 px-2">

                        <!-- Total Consumption -->
                        <div class="flex-[1] self-center min-w-[300px] max-w-[600px]">
                            <app-custom-number-input labelText="{{ 'dashboard.labels.totalConsumption' | transloco }}"
                                [inputId]="'totalConsumption'" [inputType]="'number'"
                                [(inputValue)]="totalConsumptionInput" [errorMessage]="totalConsumptionInputError"
                                placeholder="{{ 'dashboard.placeholders.totalConsumption' | transloco }}"
                                [isDisabled]="saveClicked" boxHeight="min-h-[50px] max-h-[70px]">
                            </app-custom-number-input>
                        </div>

                        <!-- Invoice Amount -->
                        <div class="flex-[1] self-center min-w-[300px] max-w-[600px]">
                            <app-custom-number-input labelText="{{ 'dashboard.labels.invoiceAmount' | transloco }}"
                                [inputId]="'invoiceAmount'" [inputType]="'number'" [(inputValue)]="invoiceAmountInput"
                                [errorMessage]="invoiceAmountInputError"
                                placeholder="{{ 'dashboard.placeholders.invoiceAmount' | transloco }}"
                                [isDisabled]="saveClicked" boxHeight="min-h-[50px] max-h-[70px]">
                            </app-custom-number-input>
                        </div>

                        <!-- Total Taxes -->
                        <div class="flex-[1] self-center min-w-[300px] max-w-[600px]">
                            <app-custom-number-input labelText="{{ 'dashboard.labels.totalTaxes' | transloco }}"
                                [inputId]="'totalTaxes'" [inputType]="'number'" [(inputValue)]="totalTaxesInput"
                                [errorMessage]="totalTaxesInputError"
                                placeholder="{{ 'dashboard.placeholders.totalTaxes' | transloco }}"
                                [isDisabled]="saveClicked" boxHeight="min-h-[50px] max-h-[70px]">
                            </app-custom-number-input>
                        </div>
                    </div>
                    <div class="w-full flex flex-wrap gap-2 px-2" *ngIf="selectedEnergyTypeDropdown == 0">

                        <!-- Month Consumption F1 -->
                        <div class="flex-[1] self-center min-w-[300px] max-w-[600px]">
                            <app-custom-number-input labelText="{{ 'dashboard.labels.monthConsumptionF1' | transloco }}"
                                [inputId]="'monthConsumptionF1'" [inputType]="'number'"
                                [(inputValue)]="monthConsumptionF1Input" [errorMessage]="monthConsumptionF1InputError"
                                placeholder="{{ 'dashboard.placeholders.monthConsumptionF1' | transloco }}"
                                [isDisabled]="saveClicked" boxHeight="min-h-[50px] max-h-[70px]">
                            </app-custom-number-input>
                        </div>

                        <!-- Month Consumption F2 -->
                        <div class="flex-[1] self-center min-w-[300px] max-w-[600px]">
                            <app-custom-number-input labelText="{{ 'dashboard.labels.monthConsumptionF2' | transloco }}"
                                [inputId]="'monthConsumptionF2'" [inputType]="'number'"
                                [(inputValue)]="monthConsumptionF2Input" [errorMessage]="monthConsumptionF2InputError"
                                placeholder="{{ 'dashboard.placeholders.monthConsumptionF2' | transloco }}"
                                [isDisabled]="saveClicked" boxHeight="min-h-[50px] max-h-[70px]">
                            </app-custom-number-input>
                        </div>

                        <!-- Month Consumption F3 -->
                        <div class="flex-[1] self-center min-w-[300px] max-w-[600px]">
                            <app-custom-number-input labelText="{{ 'dashboard.labels.monthConsumptionF3' | transloco }}"
                                [inputId]="'monthConsumptionF3'" [inputType]="'number'"
                                [(inputValue)]="monthConsumptionF3Input" [errorMessage]="monthConsumptionF3InputError"
                                placeholder="{{ 'dashboard.placeholders.monthConsumptionF3' | transloco }}"
                                [isDisabled]="saveClicked" boxHeight="min-h-[50px] max-h-[70px]">
                            </app-custom-number-input>
                        </div>

                        <!-- Energy Charge Price -->
                        <div class="flex-[1] self-center min-w-[300px] max-w-[600px]">
                            <app-custom-number-input labelText="{{ 'dashboard.labels.energyChargePrice' | transloco }}"
                                [inputId]="'energyChargePrice'" [inputType]="'number'"
                                [(inputValue)]="energyChargePriceInput" [errorMessage]="energyChargePriceInputError"
                                placeholder="{{ 'dashboard.placeholders.energyChargePrice' | transloco }}"
                                [isDisabled]="saveClicked" boxHeight="min-h-[50px] max-h-[70px]">
                            </app-custom-number-input>
                        </div>

                        <!-- Reactive Energy Costs -->
                        <div class="flex-[1] self-center min-w-[300px] max-w-[600px]">
                            <app-custom-number-input labelText="{{ 'dashboard.labels.reactiveEnergyCosts' | transloco }}"
                                [inputId]="'reactiveEnergyCosts'" [inputType]="'number'"
                                [(inputValue)]="reactiveEnergyCostsInput" [errorMessage]="reactiveEnergyCostsInputError"
                                placeholder="{{ 'dashboard.placeholders.reactiveEnergyCosts' | transloco }}"
                                [isDisabled]="saveClicked" boxHeight="min-h-[50px] max-h-[70px]">
                            </app-custom-number-input>
                        </div>

                        <!-- TMS Charges -->
                        <div class="flex-[1] self-center min-w-[300px] max-w-[600px]">
                            <app-custom-number-input labelText="{{ 'dashboard.labels.tmsCharges' | transloco }}"
                                [inputId]="'tmsCharges'" [inputType]="'number'" [(inputValue)]="tmsChargesInput"
                                [errorMessage]="tmsChargesInputError"
                                placeholder="{{ 'dashboard.placeholders.tmsCharges' | transloco }}"
                                [isDisabled]="saveClicked" boxHeight="min-h-[50px] max-h-[70px]">
                            </app-custom-number-input>
                        </div>

                        <!-- Dispatch Costs -->
                        <div class="flex-[1] self-center min-w-[300px] max-w-[600px]">
                            <app-custom-number-input labelText="{{ 'dashboard.labels.dispatchCosts' | transloco }}"
                                [inputId]="'dispatchCosts'" [inputType]="'number'" [(inputValue)]="dispatchCostsInput"
                                [errorMessage]="dispatchCostsInputError"
                                placeholder="{{ 'dashboard.placeholders.dispatchCosts' | transloco }}"
                                [isDisabled]="saveClicked" boxHeight="min-h-[50px] max-h-[70px]">
                            </app-custom-number-input>
                        </div>

                    </div>
                    <div class="w-full flex flex-wrap gap-2 px-2" *ngIf="selectedEnergyTypeDropdown == 1">

                        <!-- Fixed Quota -->
                        <div class="flex-[1] self-center min-w-[300px] max-w-[600px]">
                            <app-custom-number-input labelText="{{ 'dashboard.labels.fixedQuota' | transloco }}"
                                [inputId]="'fixedQuota'" [inputType]="'number'" [(inputValue)]="fixedQuotaInput"
                                [errorMessage]="fixedQuotaInputError"
                                placeholder="{{ 'dashboard.placeholders.fixedQuota' | transloco }}"
                                [isDisabled]="saveClicked" boxHeight="min-h-[50px] max-h-[70px]">
                            </app-custom-number-input>
                        </div>

                        <!-- Spread -->
                        <div class="flex-[1] self-center min-w-[300px] max-w-[600px]">
                            <app-custom-number-input labelText="{{ 'dashboard.labels.spread' | transloco }}"
                                [inputId]="'spread'" [inputType]="'number'" [(inputValue)]="spreadInput"
                                [errorMessage]="spreadInputError"
                                placeholder="{{ 'dashboard.placeholders.spread' | transloco }}"
                                [isDisabled]="saveClicked" boxHeight="min-h-[50px] max-h-[70px]">
                            </app-custom-number-input>
                        </div>

                        <!-- TMS Charges -->
                        <div class="flex-[1] self-center min-w-[300px] max-w-[600px]">
                            <app-custom-number-input labelText="{{ 'dashboard.labels.tmsCharges' | transloco }}"
                                [inputId]="'tmsCharges'" [inputType]="'number'" [(inputValue)]="tmsChargesInput"
                                [errorMessage]="tmsChargesInputError"
                                placeholder="{{ 'dashboard.placeholders.tmsCharges' | transloco }}"
                                [isDisabled]="saveClicked" boxHeight="min-h-[50px] max-h-[70px]">
                            </app-custom-number-input>
                        </div>
                    </div>
                </div>

                <div *ngIf="dialogErrorMessage" class="flex items-center text-error mt-2 text-sm">
                    <img src="assets/icons/close-circle.svg" alt="{{ 'shared.components.error_icon' | transloco }}"
                        class="w-5 h-5" />
                    <p class="ml-1">{{ dialogErrorMessage }}</p>
                </div>
                <div class="flex w-full gap-4">
                    <div class="flex-[1] h-[45px]">
                        <app-custom-button buttonText="{{ 'shared.cancel' | transloco }}" (buttonClick)="closeModal()"
                            backgroundColor="bg-[#FFFFFF]" textColor="text-secondary" borderColor="border-secondary"
                            hoverBackgroundColor="hover:bg-secondary"
                            hoverBorderColor="hover:border-secondary"></app-custom-button>
                    </div>
                    <div class="flex-[1] h-[45px]">
                        <app-custom-button buttonText="{{ 'shared.confirm' | transloco }}"
                            (buttonClick)="confirmButtonClick()" backgroundColor="bg-primary" textColor="text-white"
                            borderColor="border-primary" hoverBackgroundColor="hover:bg-primary-1200"
                            [isDisabled]="confirmClicked"></app-custom-button>
                    </div>
                </div>

            </div>
        </div>
    </ng-template>
</p-dialog>